/* @flow */
export const A11Y_HIDE_FOCUS_STYLE: 'A11Y_HIDE_FOCUS_STYLE' = 'A11Y_HIDE_FOCUS_STYLE';
export const A11Y_SHOW_FOCUS_STYLE: 'A11Y_SHOW_FOCUS_STYLE' = 'A11Y_SHOW_FOCUS_STYLE';
export const ADD_ANSWER: 'ADD_ANSWER' = 'ADD_ANSWER';
export const INBOXES_SET_INBOX: 'INBOXES_SET_INBOX' = 'INBOXES_SET_INBOX';
export const INBOXES_SET_THREAD: 'INBOXES_SET_THREAD' = 'INBOXES_SET_THREAD';
export const INCREMENT_PROGRESS: 'INCREMENT_PROGRESS' = 'INCREMENT_PROGRESS';
export const USER_CONFIRM_SOUND: 'USER_CONFIRM_SOUND' = 'USER_CONFIRM_SOUND';
export const USER_SET_GENDER: 'USER_SET_GENDER' = 'USER_SET_GENDER';
export const USER_SET_PIN: 'USER_SET_PIN' = 'USER_SET_PIN';
export const USER_SET_TRACK: 'USER_SET_TRACK' = 'USER_SET_TRACK';
export const VIDEO_LOADED: 'VIDEO_LOADED' = 'VIDEO_LOADED';
export const VIDEO_PLAY: 'VIDEO_PLAY' = 'VIDEO_PLAY';
export const VIDEO_RESET: 'VIDEO_RESET' = 'VIDEO_RESET';



// WEBPACK FOOTER //
// ./src/constants/action-types.js